import { AwaitResponse } from '@/utils/MockUtils';
import { limitsAndUsageExtras, servicesAndLimitsHospital, memberHistory } from '@/constants/LimitsUsageMockApiData';
import AbstractClass from './LimitsUsageAbstractServices';

export default class LimitsUsageServices extends AbstractClass {
  static getReferenceData() {
    const mockData = {
      limitsAndUsageInformationText: {
        informationText:
          'View each person&rsquo;s limits and usage below.<br />\r\n<br />\r\nPolicy holders and full access members will see the limits usage against all members on a policy except where a member has the privacy flag.<br />\r\n<br />\r\nPayment of benefits is subject to terms and conditions, waiting periods, and claims history (including with another health fund).<br />\r\n<br />\r\nBefore you make any decisions about your hospital choice or procedures, check your <a href="\\#{productGuideLink}\\" target="_blank">product guide</a> and <a href="https://www.defencehealth.com.au/Support/Fund-rules">fund rules</a> for exactly what your level of cover includes, and that you have served any waiting periods. Or you can even do a <a href="/$memberNumber$/my-claims/benefit-quotes/get-a-benefit-quote">benefit quote</a> for a detailed outline of benefits and limits. Details of former members are not displayed. Please call us if you have questions about former members.<br />\r\n<br />\r\n<strong>Most limits reset on 1 July each year.</strong>',
      },
      limitsAndUsageCalloutText: {
        informationText:
          `
          <h3>Viewing service categories<strong></strong></h3>
          <p><strong>Filtering</strong> on the following services will display additional content for their related sub limits, <strong>if </strong>they are covered on your policy:</p>
          <ul>
          <li>Flexi-Limit</li>
          <li>Health and Wellbeing</li>
          <li>Medically Prescribed Devices and Appliances</li>
          </ul>
          `,
      },
      limitsAndUsageHospitalServicesInformationText: {
        informationText:
          'This table only displays included hospital services that have a limit.<br />\r\n<br />\r\nThere is no excess applicable for dependants.<br />\r\n<br />\r\nYour usage history for hospital excess and services can be searched starting from 01 / 07 / 2021.',
      },
      limitsAndUsageExtrasServicesInformationText: {
        informationText:
          'View each person&#39;s extras benefit limits and usage below.<br />\r\n<br />\r\nSub-limits and longer benefit periods may apply in some service categories.<br />\r\n<br />\r\nFor example, some medically prescribed devices can only be claimed once every 3 years from date of purchase, the laser refractive eye surgery limit can be claimed every 2 financial years; and under Major Dental a complete denture (item 719) can only be claimed once every 3 financial years.',
      },
      servicesOptions: [
        {
          display: 'Alternative Therapies',
          returnValue: 'alternativeTherapies',
        },
        {
          display: 'Ambulance',
          returnValue: 'ambulance',
        },
        {
          display: 'Flexi-Limit',
          returnValue: 'Flexi limit modalities',
        },
        {
          display: 'General Dental',
          returnValue: 'generalDental',
        },
        {
          display: 'Health and Well-being',
          returnValue: 'healthAndWellbeing',
        },
        {
          display: 'Laser Refractive Eye Surgery',
          returnValue: 'laserRefractiveEyeSurgery',
        },
        {
          display: 'Major Dental',
          returnValue: 'majorDental',
        },
        {
          display: 'Medically Prescribed Devices',
          returnValue: 'Medically prescribed devices',
        },
        {
          display: 'Optical',
          returnValue: 'optical',
        },
        {
          display: 'Orthodontics',
          returnValue: 'orthodontics',
        },
        {
          display: 'School Accidents',
          returnValue: 'schoolAccidents',
        },
      ],
      consumptionOnlyOptions: [
        {
          name: 'Flexi Limit',
          tableTitle: 'Flexi-Limit',
          contentKey: 'limitsAndUsageFlexiLimitInformationText',
        },
        {
          name: 'Health and Wellbeing Limit',
          tableTitle: 'Health and wellbeing',
          contentKey: 'limitsAndUsageHealthAndWellbeingInformationText',
        },
      ],
      subLimitsOptions: [
        {
          limitName: 'Med Prescribed Devices & Apps',
          tableTitle: 'Medically prescribed devices and appliances',
          contentKey: 'limitsAndUsageMedicallyPrescribedDevicesInformationText',
          modalities: [
            {
              name: 'Non-Cosmetic Prostheses',
              tableTitle: 'Non-cosmetic prosthesis',
              contentKey: 'limitsAndUsageNonCosmeticProsthesesInformationText',
              subSubLimits: [
                {
                  name: 'Artificial Eye Limit',
                },
                {
                  name: 'External Breast Prosthesis',
                },
                {
                  name: 'Wig',
                },
              ],
            },
          ],
        },
      ],
      replacementPeriodsOptions: [
        {
          name: 'Med Prescribed Devices & Apps',
          tableTitle: 'Medically prescribed devices and appliances',
          contentKey: 'limitsAndUsageMedicallyPrescribedDevicesInformationText',
        },
      ],
      limitsAndUsageFlexiLimitInformationText: {
        informationText: '<h3><strong>Flexi-limit category</strong></h3>\r\nThe flexi-limit can be used across a range of included services.',
      },
      limitsAndUsageHealthAndWellbeingInformationText: {
        informationText: '<h3><strong>Health and wellbeing category</strong></h3>\r\nThe health and wellbeing limit can be used across a range of included services.',
      },
      limitsAndUsageMedicallyPrescribedDevicesInformationText: {
        informationText:
          '<h3><strong>Medically prescribed devices and appliances</strong></h3>\r\nSome devices and appliances can only be claimed once every 3 years from date of purchase. Benefit limits, benefit periods and sub limits may apply and vary between items.<br />\r\n<br />\r\nTo see your limits, what you&rsquo;ve used and if an item is claimable, complete a benefit quote for a detailed outline. Or check your product guide or call us.',
      },
      limitsAndUsageNonCosmeticProsthesesInformationText: {
        informationText:
          '<h3><strong>Non-cosmetic prostheses (sub-category of devices and appliances)</strong></h3>\r\nSub-limits apply to the following non-cosmetic prostheses (artificial eye claimable once every 3 years).',
      },
      limitsAndUsageThreeYearBenefitInformationText: {
        informationText: '<h3><strong>Three-year benefit period</strong></h3>\r\nBenefits for the following devices can be claimed once every 3 years.',
      },
      limitsAndUsagePreFooterInformationText: {
        informationText: '',
      },
    };
    return AwaitResponse(JSON.parse(JSON.stringify(mockData).tokenSwap()));
  }

  static retrieveReplacementPeriods() {
    return AwaitResponse([
      {
        replacementPeriod: 2,
        replacementPeriodUom: 'Y',
        providerLimitRuleList: [
          {
            code: 'LASER_REF_SUR',
            descr: 'Laser refractive eye surgery',
          },
        ],
      },
      {
        replacementPeriod: 3,
        replacementPeriodUom: 'Y',
        providerLimitRuleList: [
          {
            code: 'MA_ROLLING_WALKERS',
            descr: 'Rolling Walkers BR Limit Rule',
          },
          {
            code: 'MA_WALKINGSTICKS',
            descr: 'Walking Sticks BR Limit Rule',
          },
          {
            code: 'MA_WALKING_FRAMES',
            descr: 'Walking Frames BR Limit Rule',
          },
          {
            code: 'NEBULISER',
            descr: 'Nebuliser BR Limit Rule',
          },
          {
            code: 'MA_REACHES',
            descr: 'Reaches BR Limit Rule',
          },
          {
            code: 'CPAP_MACHINE',
            descr: 'CPAP machine BR Limit Rule',
          },
          {
            code: 'MA_CRUTCHES',
            descr: 'Crutches BR Limit Rule',
          },
          {
            code: 'BLD_GLC_MON',
            descr: 'Blood Glucose monitor BR Limit Rule',
          },
          {
            code: 'MA_WHEELCHAIR',
            descr: 'Wheelchair BR Limit Rule',
          },
          {
            code: 'BLD_PRS_MON',
            descr: 'Blood pressure monitor BR Limit Rule',
          },
          {
            code: 'ART_EYE',
            descr: 'Artificial Eye BR Limit Rule',
          },
          {
            code: 'MA_SEAT_RIS_CUSH',
            descr: 'Seat Riser Cushions BR Limit Rule',
          },
          {
            code: 'HEARING_AIDS',
            descr: 'Hearing Aids BR Limit Rule',
          },
          {
            code: 'TENS_MACHINE',
            descr: 'Tens Machine BR Limit Rule',
          },
          {
            code: 'MA_ADJ_CANES',
            descr: 'Adjustable canes BR Limit Rule',
          },
        ],
      },
    ]);
  }

  static retrieveLimitsAndUsage() {
    // Mock data will already be parsed, since the services layer will transform the response string to parsed data, and extract the array to pass into the Vue component.
    return AwaitResponse(limitsAndUsageExtras.limitsAndConsumption);
  }

  static getMemberHistory() {
    return AwaitResponse(memberHistory.members);
  }

  static retrieveServicesAndLimits() {
    return AwaitResponse(servicesAndLimitsHospital.limitsAndConsumption);
  }
}
